import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';

import css from '@features/confirm-pin/styles/PinFormV4.module.css';
import { BannerV4 } from '@shared/ui/v4';
import Timer from '@shared/ui/timer/ui/Timer';
import RoundLoader from '@shared/ui/round-loader/ui/RoundLoader';
import Alert from '@shared/ui/alert/ui/Alert';
import { useOTPLogic } from '@features/otp-verification/model/useOTPLogic';

const PinFormV4: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const {
    pin,
    invalidLength,
    errors,
    inputId,
    subscribeData,
    btnLoading,
    otpDigitsCount,
    minPinLength,
    maxPinLength,
    antifraudUniqueId,
    MAHESecondClickId,
    handlePinChange,
    handleSubmit,
  } = useOTPLogic({ variant: 'standard' });

  const inputPlaceholder = Array(otpDigitsCount).fill('_').join(' ');
  const isResendOTPAvailable = !!subscribeData?.isResendOTP;
  const phoneNumber = subscribeData?.msisdn || '';

  return (
    <form className={css.wrapper} onSubmit={(e) => handleSubmit(e)} id="otp-pin-form">
      <BannerV4 />

      <p className={css.activateAccountText}>{t('verification')}</p>

      <div className={css.codeInfoContainer}>
        <p className={css.grayText}>{t('enter_pin')}</p>
        {phoneNumber ? (
          <p className={css.grayText}>
            {t('please_enter_otp_sent_to_your_mobile_number')} {phoneNumber}
          </p>
        ) : null}
      </div>

      <div className={css.inputContainer}>
        <input
          className={cn(css.otpInput, errors.pin ? css.otpInputError : '')}
          id={inputId}
          type="tel"
          placeholder={inputPlaceholder}
          value={pin}
          onChange={handlePinChange}
          minLength={minPinLength}
          maxLength={maxPinLength}
          autoComplete="new-password"
          name="pin"
        />
        {errors.pin ? (
          <p className={cn(css.grayText, css.errorText)}>{t('invalid_pin')}</p>
        ) : null}
      </div>

      <button
        type="submit"
        className={css.submitBtn}
        disabled={btnLoading || invalidLength}
        id="submit-otp"
      >
        {btnLoading ? <RoundLoader /> : t('confirm')}
      </button>

      {isResendOTPAvailable ? (
        <div className={css.resendPinContainer}>
          {/* @ts-ignore */}
          <Timer pin={pin} antifraudUniqueId={antifraudUniqueId} clickId={MAHESecondClickId} />
        </div>
      ) : null}

      <Alert />

      <button type="button" className={css.wrongNumberBtn} onClick={() => history.goBack()}>
        Wrong number?
      </button>
    </form>
  );
};

export default PinFormV4;
